import React, { useEffect, useState } from "react";
import "./index.css"; // Ensure to create this CSS file

export default function CheckAnimation() {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsChecked(true), 1500); // Delay animation start
  }, []);

  return (
    <div className="main-container">
      <div className={`check-container ${isChecked ? "checked" : ""}`}>
        <div className="check-background">
          <svg viewBox="0 0 65 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 30 L25 48 L62 2"
              stroke="#fff"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
       
        <div className="check-shadow"></div>
      </div>
      Order Placed Successfully!
    </div>
  );
}
